/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const CloseIcon = createIcon(
  '0 0 20 20',
  <path d="M8.63 10 3.5 15.13l1.37 1.37L10 11.37l5.13 5.13 1.37-1.37L11.37 10l5.13-5.13-1.37-1.37L10 8.63 4.87 3.5 3.5 4.87z" />,
);
